module.exports = __webpack_public_path__ + "static/media/icw_logo.555d3d4b.svg";